// eslint-disable-next-line no-restricted-imports -- This file is the Kobo wrapper for the component
import { PasswordInput as PasswordInputMantine } from '@mantine/core'
import type { PasswordInputProps as PasswordInputPropsMantine } from '@mantine/core'

export type PasswordInputProps = PasswordInputPropsMantine

export default PasswordInputMantine
